import i18n from 'i18next';

/**
 * Formats a time string in the format "HH:MM AM/PM" to a localized string.
 * If the language is Arabic, it converts numbers to Eastern Arabic numerals.
 *
 * @param input - The time string to format, e.g., "02:30 PM".
 * @returns A formatted time string, e.g., "٢:٣٠ م" in Arabic or "2:30 PM" in English.
 */
export function formatLocalizedTime(input: string): string {
  if (!input) return '';

  const [time, period] = input.split(' ');
  const [hour, minute] = time.split(':');

  const localizedHour = i18n.language === 'ar' ? toEasternNum(hour) : hour;
  const localizedMinute =
    i18n.language === 'ar' ? toEasternNum(minute) : minute;

  const translatedPeriod =
    period === 'AM'
      ? i18n.t('time.AM')
      : period === 'PM'
        ? i18n.t('time.PM')
        : period;

  return `${localizedHour}:${localizedMinute} ${translatedPeriod}`;
}

function toEasternNum(num: string): string {
  const eastern = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return num.replace(/\d/g, (d) => eastern[+d]);
}
